import {Component, OnInit, ViewChild} from '@angular/core';
import {AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Observable} from 'rxjs';
import {LoanService} from '../../shared-component/service/loan/loan.service';
import {DeviceDetectorService} from 'ngx-device-detector';
import {HttpHeaders} from '@angular/common/http';

@Component({
  selector: 'app-kyc-done',
  templateUrl: './change-address.component.html',
  styleUrls: ['./change-address.component.scss']
})
export class ChangeAddressComponent implements OnInit {

  private token: string;

  public deviceType: string;
  public form: FormGroup;
  public loanDetails: any;
  public popupContext: {title: string, file?: string, type: string};
  public isConnected = true;

  @ViewChild('popup') modalTemplate: any;

  public cameraConfig: {
    showCamera: boolean,
    currentEntity: AbstractControl
  } = {
    showCamera: false,
    currentEntity: null
  };

  constructor(
    public router: Router,
    public fb: FormBuilder,
    public modalService: NgbModal,
    public loanService: LoanService,
    public deviceService: DeviceDetectorService,
    public activeRoute: ActivatedRoute
  ) {
  }

  ngOnInit() {
    this.findDeviceType();
    this.initializeForm();
    this.activeRoute.data.subscribe(res => {
      this.loanDetails = res.loanDetail;
      this.token = this.loanDetails.token;
    });
  }

  findDeviceType() {
    if (this.deviceService.isMobile()) {
      this.deviceType = 'mobile';
    }
    if (this.deviceService.isTablet()) {
      this.deviceType = 'tablet';
    }
    if (this.deviceService.isDesktop()) {
      this.deviceType = 'desktop';
    }
  }

  initializeForm() {
    this.form = this.fb.group({
      addressProofType: ['', Validators.compose([Validators.required])],
      addressProofFront: [null, Validators.compose([Validators.required])],
    });
    this.form.get('addressProofType').valueChanges.subscribe((o) => {
      if (o === "LEASE_AGREEMENT") {
        this.form.addControl('addressProofBack', new FormControl(null, Validators.compose([Validators.required])));
      } else {
        if (this.form.get('addressProofBack')) this.form.removeControl('addressProofBack');
      }
    });
  }

  getImageQuality(size) {
    let map = [{
      min: 0,
      max: 100000,
      quality: 0.8
    }, {
      min: 101000,
      max: 500000,
      quality: 0.35
    }, {
      min: 501000,
      max: 1000000,
      quality: 0.07
    }, {
      min: 1001000,
      max: 2000000,
      quality: 0.011
    }].find(o => {
      return size >= o.min && size < o.max;
    });

    if(map) return map.quality;
    return 0.0009;
  }

  openFileChooser(entity: AbstractControl, event: HTMLInputEvent, capture?: false) {
    if(event.target.files.length) {
      if(['image/jpeg'].indexOf(event.target.files[0].type) !== -1) {
        const fileName = event.target.files[0].name;
        const reader = new FileReader();
        const img : any = new Image();
        const elem = document.createElement('canvas');

        reader.readAsDataURL(event.target.files[0]);
        reader.onload = () => {
          img.src = reader.result;

          img.onload = () => {
            elem.width = img.width;
            elem.height = img.height;

            const ctx = elem.getContext('2d');

            ctx.drawImage(img, 0, 0, img.width, img.height);
            ctx.canvas.toBlob((blob) => {
              const file = new File([blob], fileName, {
                type: event.target.files[0].type,
                lastModified: Date.now()
              });

              entity.setValue(file);
              event.target.value = '';
            }, event.target.files[0].type, this.getImageQuality(event.target.files[0].size));
          };

          reader.onerror = error => {
            event.target.value = '';
            entity.setValue(null);
            console.log(error)
          };
        };
      } else {
        entity.setValue(event.target.files[0]);
      }
    } else {
      entity.setValue(null);
    }
  }

  openCamera(entity: AbstractControl) {
    this.cameraConfig.showCamera = true;
    this.cameraConfig.currentEntity = entity;
  }

  submitForm() {
    let formData = new FormData();
    let headers = new HttpHeaders();
    if(this.form.get('addressProofType') && this.form.get('addressProofType').value){
      headers = headers.set('addressProofType', this.form.get('addressProofType').value)
    }

    formData.append('addressProofFront', this.form.get('addressProofFront').value, this.form.get('addressProofFront').value.name);
    if(this.form.get('addressProofBack') && this.form.get('addressProofBack').value){
      formData.append('addressProofBack', this.form.get('addressProofBack').value, this.form.get('addressProofBack').value.name);
    }

    this.loanService.documentsSmall(formData, this.token, headers).subscribe((res: any) => {
      debugger
      this.router.navigateByUrl(`/loan/process/${this.token}/account`, {replaceUrl: true});
    });
  }

  showFile(file: File | null, title: string) {
    if(file) {
      this.popupContext = {title: title, type: file.type};
      this.getDataURL(file).subscribe(data => {
        this.popupContext.file = data;
      });
      this.modalService.open(this.modalTemplate);
    }
  }

  getDataURL(file: File) {
    return Observable.create(observer => {
      if(!file) return observer.next(null);

      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        observer.next(reader.result);
      };
      reader.onerror = function (error) {
        observer.next(null);
        console.log('Error: ', error);
      };
    });
  }
  removeDataAddress(){
    this.form.get('addressProofFront').setValue("");
    if(this.form.get('addressProofBack') && this.form.get('addressProofBack').value)
      this.form.get('addressProofBack').setValue("");
  }
  getAllErrors(form: FormGroup | FormArray): { [key: string]: any; } | null {
    let hasError = false;
    const result = Object.keys(form.controls).reduce((acc, key) => {
      const control = form.get(key);
      const errors = (control instanceof FormGroup || control instanceof FormArray)
        ? this.getAllErrors(control)
        : control.errors;
      if (errors) {
        acc[key] = errors;
        hasError = true;
      }
      return acc;
    }, {} as { [key: string]: any; });
    return hasError ? result : null;
  }
}

interface HTMLInputEvent extends Event {
  target: HTMLInputElement & EventTarget;
}
